import { Group, RingProgress, Title } from "@mantine/core"

import { ActivityProgressIcon } from "~/pages/SupplierPortal/TraceabilityRequests/components/ActivityProgressIcon"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/TraceabilityOperationsContext"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { useGetOperations } from "~/utils/operations"

export const ActivityTitle = () => {
  const { operationItem, isTransferred } = useTraceabilityOperations()
  const { progressByOperationId } = useInformationRequestContext()
  const activityName = operationItem.activityName
  const operation = useGetOperations()[activityName]
  if (!operation) return null

  return (
    <Group wrap="nowrap" align="center">
      <RingProgress
        size={40}
        roundCaps
        styles={{
          label: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
        thickness={4}
        sections={[
          {
            value: progressByOperationId[operationItem.operation?.id ?? 0],
            color: isTransferred ? "blue" : "primary",
          },
        ]}
        label={
          <ActivityProgressIcon
            progress={progressByOperationId[operationItem.operation?.id ?? 0]}
            activityName={activityName}
            size={20}
            isTransferred={isTransferred}
          />
        }
      />
      <Title size={14} order={5}>
        {operation.name}
      </Title>
    </Group>
  )
}
